// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Activités
export default class Activite  {
  // Identifiant unique
  public id: number;
  // Code
  public code: string;
  // Libellé
  public label: string;
  // Artiste
  public artiste: boolean;
  // Couleur afficher dans la frise
  public color: string;
  // Rubrique par défaut
  public defRubrique: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.label = '';
    this.artiste = false;
    this.color = '';
    this.defRubrique = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Activite): Activite {
    const newActivite: Activite = new Activite();
    newActivite.id = obj.id;
    newActivite.code = obj.code;
    newActivite.label = obj.label;
    newActivite.artiste = obj.artiste;
    newActivite.color = obj.color;
    newActivite.defRubrique = obj.defRubrique;
    newActivite.createId = obj.createId;
    newActivite.failed = obj.failed;
    newActivite.canUpdate = obj.canUpdate;
    newActivite.canDelete = obj.canDelete;
    newActivite.display = obj.display;
    newActivite.notifDefType = obj.notifDefType;
    return newActivite;
  }

  public toJsonActivite (): string {
    const json = {
      code: this.code,
      label: this.label,
      artiste: this.artiste,
      color: this.color,
      defRubrique: this.defRubrique,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromActivite (obj: Activite): void {
    this.id = obj.id;
    this.code = obj.code;
    this.label = obj.label;
    this.artiste = obj.artiste;
    this.color = obj.color;
    this.defRubrique = obj.defRubrique;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareActivite (value: Activite): boolean {
    return (this.toJsonActivite() == value.toJsonActivite());
  }

  public cloneActivite (): Activite {
    return Activite.fromJson(this);
  }

  public createForStoreActivite (): Promise<Activite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/activites/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromActivite(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreActivite (): Promise<Activite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/activites/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromActivite(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreActivite (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/activites/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/activites/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Activites/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Activite.fromJson(listData.reccords[0] as Activite);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Activite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Activites/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Activite.fromJson(listData.reccords[0] as Activite);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(activites: Activite[]) {
  }
}
